import { useMutation } from '@tanstack/react-query';

import { useApiSDK } from '../../contexts/apiSdkContext';

type TTokens = {
  accessToken: string;
  refreshToken: string;
};

type TRefreshTokensHook = {
  isError: boolean;
  isLoading: boolean;
  refreshTokenMutation: (refreshToken: string) => Promise<TTokens | undefined>;
};

function useRefreshTokens(): TRefreshTokensHook {
  const sdk = useApiSDK();

  const {
    mutateAsync: refreshTokenMutation,
    isError,
    isLoading,
  } = useMutation({
    mutationFn: async (refreshToken: string) => {
      const data = await sdk.auth.refresh(refreshToken);
      return data;
    },
  });

  return { isError, isLoading, refreshTokenMutation };
}

export { useRefreshTokens };
